export class FileNotSupported extends Error {
	constructor(message = 'Not supported file') {
		super(message);
	}
}
